export default "__VITE_ASSET__41553meU__"